import express from 'express'
import User from '../models/user'
import Wallet from '../models/wallet'
const router = express.Router()

router.get('/', (req, res) => {
    res.send('Api is working fine !')
})
router.get('/test',async (req,res)=>{
    var user =  await User.emailLogin({email:"jameel@gmail.com",password:"sucrin4you"});

    res.send(user)
});
router.get("/test2",(req,res)=>{
    var wallet = new Wallet({name:"test name ",description:"test description"})
    wallet.save();
    res.send(wallet)
})


export default router